export default "__VITE_ASSET__BV9Ysky2__"